export enum BarcodeType {
  EAN_8 = "EAN-8",
  EAN_13 = "EAN-13",
  UPC_A = "UPC-A",
  UPC_E = "UPC-E",
  ISBN_10 = "ISBN-10",
  ISBN_13 = "ISBN-13",
}
